import React from "react";
import AddressLink from "../../components/AddressLink";

export default function StudentDetailInfoSection({
  viewingStudent,
  faithStateStyles
}) {
  return (
    <div className="w-full space-y-1 mb-8">
      <h3 className="text-xl font-bold text-gray-900 mb-4 px-1">학생 정보</h3>

      <div className="flex justify-between items-center py-4 px-1 border-b border-gray-50">
        <span className="text-gray-500 font-medium text-base">생년월일</span>
        <span className="text-gray-900 font-bold text-xl">{viewingStudent.birth}</span>
      </div>
      <div className="flex justify-between items-center py-4 px-1 border-b border-gray-50">
        <span className="text-gray-500 font-medium text-base">연락처</span>
        <span className="text-gray-900 font-bold text-xl">{viewingStudent.phone}</span>
      </div>

      {!viewingStudent.isTeacher && (viewingStudent.guardian1Name || viewingStudent.guardian1Phone) && (
        <div className="flex justify-between items-center py-4 px-1 border-b border-gray-50">
          <span className="text-gray-500 font-medium text-base">보호자1 {viewingStudent.guardian1Name ? `(${viewingStudent.guardian1Name})` : ""}</span>
          <a href={`tel:${viewingStudent.guardian1Phone}`} className="text-[#354F38] font-bold text-xl underline underline-offset-2">
            {viewingStudent.guardian1Phone}
          </a>
        </div>
      )}

      {!viewingStudent.isTeacher && (viewingStudent.guardian2Name || viewingStudent.guardian2Phone) && (
        <div className="flex justify-between items-center py-4 px-1 border-b border-gray-50">
          <span className="text-gray-500 font-medium text-base">보호자2 {viewingStudent.guardian2Name ? `(${viewingStudent.guardian2Name})` : ""}</span>
          <a href={`tel:${viewingStudent.guardian2Phone}`} className="text-[#354F38] font-bold text-xl underline underline-offset-2">
            {viewingStudent.guardian2Phone}
          </a>
        </div>
      )}

      <div className="flex justify-between items-center py-4 px-1 border-b border-gray-50">
        <span className="text-gray-500 font-medium text-base">학교/직장</span>
        <span className="text-gray-900 font-bold text-xl">{viewingStudent.school}</span>
      </div>
      <div className="flex justify-between items-center py-4 px-1 border-b border-gray-50">
        <span className="text-gray-500 font-medium text-base">주소</span>
        <AddressLink
          address={viewingStudent.address}
          className="text-gray-900 font-bold text-lg text-right truncate pl-4"
        />
      </div>
      {!viewingStudent.isTeacher && (
        <div className="flex justify-between items-center py-4 px-1 border-b border-gray-50">
          <span className="text-gray-500 font-medium text-base">신앙상태</span>
          <span className={`font-bold text-lg px-4 py-1.5 rounded-xl border min-w-[80px] text-center inline-block shadow-sm ${faithStateStyles[viewingStudent.faithState] || "bg-gray-50 text-gray-800 border-gray-100"}`}>
            {viewingStudent.faithState || "-"}
          </span>
        </div>
      )}
    </div>
  );
}
